// extracted by mini-css-extract-plugin
export default {"visuallyhidden":"user-group-list-component__visuallyhidden--vNMCv","focusable":"user-group-list-component__focusable--X779X","meatball":"user-group-list-component__meatball--rL4ap"};